import { render, staticRenderFns } from "./SampleByQuotationList.vue?vue&type=template&id=96c12c96"
import script from "./SampleByQuotationList.vue?vue&type=script&lang=js"
export * from "./SampleByQuotationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports